
// the save comparison Alpine object
window.appSaveComparison = () => {
    return {
        status: false,
        init: function() {
            axios.get(buildPath([
                '/api/saved-comparison',
                this.$component('appComparison').players[1].id,
                this.$store.season1Id,
                this.$component('appComparison').players[2].id,
                this.$store.season2Id,
                this.$store.stats.join(',')
            ]))
                .then( response => {
                    if( response.data == '1' ) {
                        this.status = 'saved';
                    } else {
                        this.status = 'default';
                    }
                })
                .catch( ajaxFail );
        },
        save: function() {
            if( this.status == 'saved') {
                return;
            }
            this.status = 'saving';
            axios.post(buildPath([
                '/api/save-comparison',
                this.$component('appComparison').players[1].id,
                this.$store.season1Id,
                this.$component('appComparison').players[2].id,
                this.$store.season2Id,
                this.$store.stats.join(',')
            ])).
                then( () => {
                    this.status = 'saved';
                    // setTimeout( () =>  this.status = 'default', 3000);
                })
                .catch( ajaxFail )
        }
    }
}
